<template>
  <div>
    <div class="img-top">
      <div class="text">活动公告</div>
    </div>
    <div class="content">
      <div class="active-item flex-row">
        <div class="board" v-for="(item, i) in list" :key="i">
          <img :src="$imgUrl + item.image" alt="" class="img-card" />
          <div class="event-title">{{ item.title }}</div>
          <div class="card-bottom flex-row justify-between">
            <div class="flex-row">
              <span class="text-time">{{ item.addTime }}</span>
              <span class="text-status">{{ item.remark }}</span>
            </div>
            <div class="more" @click="cli(item.id)">查看详情 》</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsListApi } from "../../http/api/ordinary.js";
export default {
  data() {
    return {
      list: [],
      query: {
        type: 1,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      newsListApi(this.query).then((res) => {
        this.list = res;
      });
    },
    cli(id) {
      this.$router.push({
        path: "/ordinaryUser/eventinfo",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.img-top {
  height: 150px;
  background-size: cover;
  -webkit-box-sizing: border-box;
  background-image: url("../../assets/image/tingdian.png");
  display: flex;
  align-items: center;
  padding-left: 2rem;
}

.text {
  font-size: 0.3rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 0.42rem;
  font-style: italic;
}

.content {
  background-color: #f5f5f5;
}

.active-item {
  width: 15.33rem;
  margin: 0 auto;
  padding-bottom: 4.34rem;
  overflow: hidden;
  flex-wrap: wrap;
}

.board {
  position: relative;
  -webkit-box-sizing: border-box;
  width: 4.97rem;
  height: 4.33rem;
  border-radius: 0.06rem;
  background-color: #ffffff;
  margin: 0.19rem 0.07rem 0;
}

.board a {
  text-decoration: none;
}

.img-card {
  width: 4.97rem;
  height: 2.73rem;
  border-radius: 0.06rem 0.06rem 0 0;
}

.event-title {
  font-size: 0.16rem;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 0.22rem;
  margin: 0.31rem 0 0 0.19rem;
}

.card-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 0.21rem 0.25rem 0.19rem;
}

.text-time {
  font-size: 0.16rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #909090;
  line-height: 0.29rem;
}

.text-status {
  font-size: 0.16rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4141;
  line-height: 0.29rem;
  margin-left: 0.23rem;
}

.more {
  font-size: 0.16rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 0.29rem;
  cursor: pointer;
}
</style>
